import { type HTMLAttributes, type JSX } from 'react';
import { cn } from '@utils/cn';

export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={cn('tw:animate-pulse tw:rounded-md tw:bg-muted', className)} {...props} />;
}
